<template>
  <!-- 承运商工作台 - 常用车辆 -->
  <div class="conBg">
    <el-row :gutter="30">
      <el-col :span="24" style="font-size: 14px">车辆信息</el-col>
      <el-col :span="24">
        <el-form
          :model="ruleFormEnv"
          :inline="true"
          :rules="rulesEnv"
          ref="ruleFormEnv"
          label-width="130px"
        >
          <el-form-item label="车牌号:" prop="licensePlateNum">
            <el-input
              disabled
              v-model="ruleFormEnv.licensePlateNum"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item v-if="!showHide" label="任务号:" prop="taskNum">
            <el-input
              disabled
              v-model="ruleFormEnv.taskNum"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="行驶证号:" prop="drivingLicenseNum">
            <el-input
              v-model="ruleFormEnv.drivingLicenseNum"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="车辆发动机号:" prop="engineNum">
            <el-input
              v-model="ruleFormEnv.engineNum"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="行驶证注册日期:" prop="dlRegistrateTime">
            <el-date-picker
              v-model="ruleFormEnv.dlRegistrateTime"
              format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="所属车队名:" prop="fleetName">
            <el-input
              v-model="ruleFormEnv.fleetName"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="车牌颜色:" prop="licensePlateColour">
            <el-select
              v-model="ruleFormEnv.licensePlateColour"
              placeholder="车牌颜色"
            >
              <el-option
                v-for="(item, index) in arrLists.colorList"
                :label="item.label"
                :value="item.value"
                :key="index"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="燃油类型:" prop="fuelType">
            <el-select v-model="ruleFormEnv.fuelType" placeholder="燃油类型">
              <el-option
                v-for="(item, index) in arrLists.fuelTypeList"
                :label="item.label"
                :value="item.value"
                :key="index"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="车辆识别码:" prop="vin">
            <el-input
              class="search_driver_input"
              clearable
              v-model="ruleFormEnv.vin"
              placeholder="车辆识别码"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="排放标准:" prop="emissionStandard">
            <el-select
              v-model="ruleFormEnv.emissionStandard"
              placeholder="排放标准"
            >
              <el-option
                v-for="(item, index) in arrLists.vehicleEmissionsList"
                :label="item.label"
                :value="item.value"
                :key="index"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="车辆出厂年月:" prop="leaveFactoryTime">
            <el-date-picker
              v-model="ruleFormEnv.leaveFactoryTime"
              format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="环保车辆类型:" prop="vehicleTypeGufen" v-if="showGufenFields">
            <el-select
              v-model="ruleFormEnv.vehicleTypeGufen"
              placeholder="环保车辆类型"
            >
              <el-option
                v-for="(item, index) in arrLists.vehicleTypeGufenList"
                :label="item.label"
                :value="item.value"
                :key="index"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="使用性质:" prop="usageTypeGufen" v-if="showGufenFields">
            <el-select v-model="ruleFormEnv.usageTypeGufen" placeholder="使用性质">
              <el-option
                v-for="(item, index) in arrLists.usageTypeGufenList"
                :label="item.label"
                :value="item.value"
                :key="index"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="车辆品牌型号:" prop="vehicleBrandGufen" v-if="showGufenFields">
            <el-input
              v-model="ruleFormEnv.vehicleBrandGufen"
              placeholder="按照行驶证内容填写"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="发动机型号:" prop="engineModelGufen" v-if="showGufenFields">
            <el-input
              v-model="ruleFormEnv.engineModelGufen"
              placeholder="按照行驶证内容填写"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="联网状态:" prop="onlinestatusGufen" v-if="showGufenFields">
            <el-select
              v-model="ruleFormEnv.onlinestatusGufen"
              placeholder="按照行驶证内容填写"
            >
              <el-option
                v-for="(item, index) in arrLists.onlineStatusList"
                :label="item.label"
                :value="item.value"
                :key="index"
              />
            </el-select>
          </el-form-item>

          <!-- 重钢字段 -->
          <el-form-item label="车辆类型:" prop="truckModel" v-if="showCGFields">
            <el-select
              v-model="ruleFormEnv.truckModel"
              placeholder="车辆类型"
              filterable
            >
              <el-option
                v-for="(item, index) in arrLists.truckModelCGList"
                :label="item.label"
                :value="item.value"
                :key="index"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="车辆品牌型号:" prop="vehicleBrand" v-if="showCGFields">
            <el-input
              v-model="ruleFormEnv.vehicleBrand"
              placeholder="按照行驶证内容填写"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="使用性质:" prop="usecharacter" v-if="showCGFields">
            <el-select v-model="ruleFormEnv.usecharacter" placeholder="使用性质">
              <el-option
                v-for="(item, index) in arrLists.useCharCGList"
                :label="item.label"
                :value="item.value"
                :key="index"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="联网状态:" prop="networkingstatus" v-if="showCGFields">
            <el-select
              v-model="ruleFormEnv.networkingstatus"
              placeholder="按照行驶证内容填写"
            >
              <el-option
                v-for="(item, index) in arrLists.onlineStatusList"
                :label="item.label"
                :value="item.value"
                :key="index"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="注册登记时间:" prop="registrationTime" v-if="showCGFields">
            <el-date-picker
              v-model="ruleFormEnv.registrationTime"
              format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24" style="font-size: 14px">附件信息</el-col>
      <el-form
        :model="ruleFormEnv"
        :rules="rulesEnv"
        ref="ruleForm1"
        label-width="140px"
        class="demo-ruleForm"
      >
        <el-col :span="12">
          <el-form-item
            label="行驶证附件:"
            prop="drivingLicenseEnclosure"
            v-model="ruleFormEnv.drivingLicenseEnclosure"
          >
            <el-upload
              class="avatar-uploader"
              :action="upload"
              :show-file-list="false"
              :on-success="drivingLicenseUpd"
              ref="uploadllalal"
              :before-upload="onlyImages"
            >
              <img
                v-if="ruleFormEnv.drivingLicenseEnclosure"
                :src="ruleFormEnv.drivingLicenseEnclosure"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="el-upload__tip">
              只能上传jpg/png/pdf文件，且不超过4Mb
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="环保附件:" prop="envUrl">
            <el-input
              style="display: none"
              v-model="ruleFormEnv.envUrl"
            ></el-input>
            <el-upload
              class="avatar-uploader"
              :action="upload"
              :show-file-list="false"
              :on-success="envProtectListUpd"
              :before-upload="onlyImages"
              ref="uploadDouble"
            >
              <img
                v-if="ruleFormEnv.envUrl"
                :src="ruleFormEnv.envUrl"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-radio-group v-model="selectLab" @change="changeLab">
              <el-radio label="环保信息随车清单"></el-radio>
              <el-radio label="环保备案附件"></el-radio>
            </el-radio-group>
            <!-- <div class="el-upload__tip">只能上传jpg/png文件，且不超过10Mb</div> -->
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item style="text-align: center" label-width="0px">
            <el-button
              v-if="this.isRecord !== '1'"
              type="primary"
              :loading="isLoading"
              @click="examine"
              >提交</el-button
            >
            <el-button type="primary" @click="$router.back()">返回</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
  </div>
</template>
<script>
import { baseGateway } from "@/api/base";
import arrLists from "@/views/Home/customerWorkbench/logisticsManagement/commonVehicles/js/columns";
import { string } from "mathjs";
export default {
  props: {
    // 任务号 是否显示
    showHide: {
      type: Boolean,
      default: false,
    },
    licensePlateNum: {
      type: String,
    },
    // 是否承运商
    isCarrier: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showGufenFields: false, // 控制宝山字段显示
      showCGFields: false, // 控制重钢字段显示
      //枚举列表
      arrLists: arrLists,
      upload: `${baseGateway()}/chem-gateway/chem-loms/file/upload`,
      ruleFormEnv: {
        licensePlateNum: "",
        drivingLicenseNum: "",
        engineNum: "",
        materialSnum: "",
        drivingLicenseEnclosure: "",
        envProtectEnclosure: null,
        envProtectList: null,
        licensePlateColour: "1",
        envUrl: "",
        taskNum: "",
        emissionStandard: "",
        dlRegistrateTime: "",
        fuelType: "",
        vin: "",
        // 股份
        vehicleTypeGufen: "",
        usageTypeGufen: "",
        vehicleBrandGufen: "",
        engineModelGufen: "",
        onlinestatusGufen: "",
        // 重钢
        truckModel: "",
        vehicleBrand: "",
        usecharacter: "",
        networkingstatus: "",
        registrationTime: "",
      },
      isLoading: false, //提交按钮加载
      selectLab: "环保信息随车清单", //环保附件 按钮选择

      isRecord: "", //是否备案 1 是 0 否
      // 环保备案校验
      rulesEnv: {
        drivingLicenseNum: [
          {
            required: true,
            message: "请输入行驶证号码",
            trigger: ["change", "blur"],
          },
        ],
        dlRegistrateTime: [
          {
            required: true,
            message: "请选择注册日期",
            trigger: ["change", "blur"],
          },
        ],
        fleetName: [
          {
            required: true,
            message: "请输入所属车队名",
            trigger: ["change", "blur"],
          },
        ],
        licensePlateColour: [
          {
            required: true,
            message: "请选择车牌颜色",
            trigger: ["change", "blur"],
          },
        ],
        fuelType: [
          {
            required: true,
            message: "请选择燃油类型",
            trigger: ["change", "blur"],
          },
        ],
        vin: [
          {
            required: true,
            message: "请输入车辆识别码",
            trigger: ["change", "blur"],
          },
        ],
        emissionStandard: [
          {
            required: true,
            message: "请选择排放标准",
            trigger: ["change", "blur"],
          },
        ],
        leaveFactoryTime: [
          {
            required: true,
            message: "请选择车辆出厂年月",
            trigger: ["change", "blur"],
          },
        ],
        businessScope: [
          {
            required: true,
            message: "请选择经营范围",
            trigger: ["change", "blur"],
          },
        ],
        engineNum: [
          {
            required: true,
            message: "请输入车辆发动机号",
            trigger: ["change", "blur"],
          },
        ],
        materialSnum: [
          {
            required: true,
            message: "请输入物资清单数量",
            trigger: ["change", "blur"],
          },
        ],
        drivingLicenseEnclosure: [
          {
            required: true,
            message: "请上传行驶证附件",
            trigger: ["change", "blur"],
          },
        ],
        envUrl: [
          {
            required: true,
            message: "请至少上传环保信息随车清单或环保附件中的一个",
            trigger: ["change", "blur"],
          },
        ],
        // 股份
        vehicleTypeGufen: [
          {
            required: false,
            message: "请选择环保车辆类型",
            trigger: ["change", "blur"],
          },
        ],
        usageTypeGufen: [
          {
            required: false,
            message: "请选择使用性质",
            trigger: ["change", "blur"],
          },
        ],
        vehicleBrandGufen: [
          {
            required: false,
            message: "请输入车辆品牌型号",
            trigger: ["change", "blur"],
          },
        ],
        engineModelGufen: [
          {
            required: false,
            message: "请输入发动机型号",
            trigger: ["change", "blur"],
          },
        ],
        onlinestatusGufen: [
          {
            required: false,
            message: "请选择联网状态",
            trigger: ["change", "blur"],
          },
        ],
        // 重钢
        truckModel: [
          {
            required: false,
            message: "请选择车辆类型",
            trigger: ["change", "blur"],
          },
        ],
        vehicleBrand: [
          {
            required: false,
            message: "请输入车辆品牌型号",
            trigger: ["change", "blur"],
          },
        ],
        usecharacter: [
          {
            required: false,
            message: "请选择使用性质",
            trigger: ["change", "blur"],
          },
        ],
        networkingstatus: [
          {
            required: false,
            message: "请选择联网状态",
            trigger: ["change", "blur"],
          },
        ],
        registrationTime: [
          {
            required: false,
            message: "请选择注册登记时间",
            trigger: ["change", "blur"],
          },
        ],
      },
    };
  },
  created() {
    // console.log(this.licensePlateNum);
    if (this.$route.query.carDetail) {
      let queryData = JSON.parse(this.$route.query.carDetail);
      // console.log(queryData);
      if (queryData.arrivalFormNum) {
        this.ruleFormEnv.taskNum = queryData.arrivalFormNum;
      } else if (queryData.billLadingNum) {
        this.ruleFormEnv.taskNum = queryData.billLadingNum;
      }
      this.ruleFormEnv.licensePlateNum = queryData.licensePlateNum || "";
      this.ruleFormEnv.emissionStandard = queryData.emissionStandard || "";

      // 根据taskNum前四位判断显示字段和必填规则(宝山 1006 和 重钢 1230 时必填)
      const taskNumPrefix = this.ruleFormEnv.taskNum.substring(0, 4);

      if (taskNumPrefix === '1006') { // 宝山
        this.showGufenFields = true; // 显示宝山
        this.showCGFields = false; // 隐藏重钢
        // 设置宝山字段必填
        this.rulesEnv.vehicleTypeGufen[0].required = true;
        this.rulesEnv.usageTypeGufen[0].required = true;
        this.rulesEnv.vehicleBrandGufen[0].required = true;
        this.rulesEnv.engineModelGufen[0].required = true;
        this.rulesEnv.onlinestatusGufen[0].required = true;
        // 设置重钢字段非必填
        this.rulesEnv.truckModel[0].required = false;
        this.rulesEnv.vehicleBrand[0].required = false;
        this.rulesEnv.usecharacter[0].required = false;
        this.rulesEnv.networkingstatus[0].required = false;
        this.rulesEnv.registrationTime[0].required = false;
      } else if (taskNumPrefix === '1230') { // 重钢
        this.showGufenFields = false;
        this.showCGFields = true;
        // 设置重钢字段必填
        this.rulesEnv.truckModel[0].required = true;
        this.rulesEnv.vehicleBrand[0].required = true;
        this.rulesEnv.usecharacter[0].required = true;
        this.rulesEnv.networkingstatus[0].required = true;
        this.rulesEnv.registrationTime[0].required = true;
        // 设置宝山字段非必填
        this.rulesEnv.vehicleTypeGufen[0].required = false;
        this.rulesEnv.usageTypeGufen[0].required = false;
        this.rulesEnv.vehicleBrandGufen[0].required = false;
        this.rulesEnv.engineModelGufen[0].required = false;
        this.rulesEnv.onlinestatusGufen[0].required = false;
      } else { // 其他情况
        this.showGufenFields = true; // 默认按宝钢显示
        this.showCGFields = false;
        // 设置宝山字段非必填
        this.rulesEnv.vehicleTypeGufen[0].required = false;
        this.rulesEnv.usageTypeGufen[0].required = false;
        this.rulesEnv.vehicleBrandGufen[0].required = false;
        this.rulesEnv.engineModelGufen[0].required = false;
        this.rulesEnv.onlinestatusGufen[0].required = false;
        // 设置重钢字段非必填
        this.rulesEnv.truckModel[0].required = false;
        this.rulesEnv.vehicleBrand[0].required = false;
        this.rulesEnv.usecharacter[0].required = false;
        this.rulesEnv.networkingstatus[0].required = false;
        this.rulesEnv.registrationTime[0].required = false;
      }

      // 赋值宝山字段（如果存在）
      this.ruleFormEnv.vehicleTypeGufen = queryData.vehicleTypeGufen || queryData.vehicleType || "";
      this.ruleFormEnv.usageTypeGufen = queryData.usageTypeGufen || queryData.usageType || "";
      this.ruleFormEnv.vehicleBrandGufen = queryData.vehicleBrandGufen || queryData.vehicleBrand || "";
      this.ruleFormEnv.engineModelGufen = queryData.engineModelGufen || queryData.engineModel || "";
      this.ruleFormEnv.onlinestatusGufen = queryData.onlinestatusGufen || queryData.onlineStatus || "";

      // 赋值重钢字段（如果存在）
      this.ruleFormEnv.truckModel = queryData.truckModel || "";
      this.ruleFormEnv.vehicleBrand = queryData.vehicleBrand || "";
      this.ruleFormEnv.usecharacter = queryData.usecharacter || "";
      this.ruleFormEnv.networkingstatus = queryData.networkingstatus || "";
      this.ruleFormEnv.registrationTime = queryData.registrationTime || "";

      if (this.isCarrier) {
        this.ruleFormEnv.dlRegistrateTime = queryData.dlRegistrateTime || "";
        this.ruleFormEnv.licensePlateColour =
          queryData.licensePlateColour || "";
        // this.ruleFormEnv.fuelType=queryData.fuelType||""
        this.ruleFormEnv.vin = queryData.vin || "";
        this.ruleFormEnv.drivingLicenseEnclosure = queryData.licenseUrlXs || "";
      }

      // drivingLicenseEnclosure
      this.isRecord = queryData.isRecord;
      if (this.isRecord == "1") {
        this.$message.success("该车辆已进行环保备案");
      } else {
        this.$message.warning("该车辆环保备案未完成");
      }
      this.backData();
    } else {
      this.ruleFormEnv.licensePlateNum = this.licensePlateNum;
    }
  },
  mounted() {
    // if(this.$route.query.carDetail){
    //     let queryData=JSON.parse(this.$route.query.carDetail)
    //     // console.log(this.selectLab,'selectLab')
    //     if(queryData.arrivalFormNum){
    //     this.ruleFormEnv.taskNum=queryData.arrivalFormNum
    //     }else if(queryData.billLadingNum){
    //     this.ruleFormEnv.taskNum=queryData.billLadingNum
    //     }
    //     this.ruleFormEnv.licensePlateNum=queryData.licensePlateNum
    //     // console.log(this.ruleFormEnv,'任务号')
    // }else{
    //      this.ruleFormEnv.licensePlateNum=this.licensePlateNum
    // }
  },
  methods: {
    changeState(val) {
      let status = "";
      switch (val) {
        case "01":
          status = "国一";
          break;
        case "02":
          status = "国二";
          break;
        case "03":
          status = "国三";
          break;
        case "04":
          status = "国四";
          break;
        case "05":
          status = "国五";
          break;
        case "06":
          status = "国六";
          break;
        case "10":
          status = "氢能";
          break;
        case "11":
          status = "电动";
          break;
      }
      return status;
    },
    changeLab(val) {
      this.ruleFormEnv.envProtectList = "";
      this.ruleFormEnv.envProtectEnclosure = "";
      this.ruleFormEnv.envUrl = "";
    },
    //上传成功  行驶证
    drivingLicenseUpd(response, file, fileList) {
      if (response.status == 200) {
        this.ruleFormEnv.drivingLicenseEnclosure = response.data;
      }
    },
    // 环保信息随车清单/环保附件
    envProtectListUpd(response, file, fileList) {
      // console.log(response,'response')
      if (response.status == 200) {
        if (this.selectLab == "环保信息随车清单") {
          this.ruleFormEnv.envProtectList = response.data;
          this.ruleFormEnv.envUrl = response.data;
          // this.$refs.uploadDouble.clearFiles();
        } else if (this.selectLab == "环保备案附件") {
          this.ruleFormEnv.envProtectEnclosure = response.data;
          this.ruleFormEnv.envUrl = response.data;
          // this.$refs.uploadDouble.clearFiles();
        }
      }
    },
    //只能上传图片
    onlyImages(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png"; //image/png
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("只能上传文件格式为jpeg,png的!");
      } else if (!isLt2M) {
        this.$message.error("上传图片大小不能超过10MB!");
      } else {
        this.$message({
          message: "正在上传中...",
          type: "info",
          duration: 2000,
        });
        // this.$message.info('正在上传文件中');
      }
      return isJPG && isLt2M;
    },
    // 保存
    save() {
      let that = this;
      that.$refs.ruleForm.validate((valid) => {
        if (valid) {
          that.$refs.ruleForm1.validate((valid) => {
            if (valid) {
              // 新增车辆
              let paramsData = {
                ...that.ruleForm,
              };
              // paramsData.businessScope = paramsData.businessScope.join(",")
              that.$api.carrier.addCarRecord(paramsData).then((res) => {
                if (res.status == 200) {
                  that.$message.success(res.msg);
                  // that.$router.push('/carrierWorkbench/myVehicle')
                } else {
                  that.$message.warning(res.msg);
                }
              });
              // }
            }
          });
        }
      });
    },
    // 提交审核
    examine() {
      let that = this;

      that.$refs.ruleFormEnv.validate((valid) => {
        if (valid) {
          that.$refs.ruleForm1.validate((valid) => {
            if (valid) {
              let paramsData = {
                ...that.ruleFormEnv,
              };
              that.isLoading = true;
              that.$api.carrier
                .addCarRecord(paramsData)
                .then((res) => {
                  if (res.status == 200) {
                    that.$message.success("环保备案已提交，等待审核");
                    that.$router.go(-1);
                  } else {
                    that.$message.warning(res.msg);
                  }
                })
                .catch(() => {
                  that.isLoading = false;
                });
            }
          });
        }
      });
    },
    //回显环保备案数据---TODO--------------
    backData() {
      //  if(this.isRecord=='1'){
      // 调查询环保备案信息的接口
      console.log(this.ruleFormEnv.licensePlateNum, 'licensePlateNum')
      this.$api.carrier
        .carRecord({
          licensePlateNum: this.ruleFormEnv.licensePlateNum,
          taskNum: this.ruleFormEnv.taskNum,
        })
        .then((res) => {
          //   console.log(res,'环保备案回显')
          if (res.status == "200") {
            if (res.data) {
              res.data.envUrl = res.data.envProtectList
                ? res.data.envProtectList
                : res.data.envProtectEnclosure;
              this.ruleFormEnv = res.data;
              if (res.data.envProtectEnclosure) {
                this.selectLab = "环保备案附件";
              } else if (res.data.envProtectList) {
                this.selectLab = "环保信息随车清单";
              }
              if (JSON.parse(this.$route.query.carDetail).arrivalFormNum) {
                this.ruleFormEnv.taskNum = JSON.parse(
                  this.$route.query.carDetail
                ).arrivalFormNum;
              } else if (
                JSON.parse(this.$route.query.carDetail).billLadingNum
              ) {
                this.ruleFormEnv.taskNum = JSON.parse(
                  this.$route.query.carDetail
                ).billLadingNum;
              }
              // this.$message.success(res.msg)
            } else {
              if (this.isRecord == "1") {
                this.$message.success("已在其它平台备案，客商无法查询详细信息");
              }
            }
          } else {
            this.$message.error(res.msg);
          }
        });
    },
  },
};
</script>
<style>
.wd350 {
  width: 350px;
}
.w_100 {
  width: 100%;
}
::v-deep .el-form-item__label {
  font-size: 12px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #fbfdff;
}
.avatar {
  width: 148px;
  height: 148px;
  display: block;
}

.top_btn {
  display: inline-block;
}

.el-row > div {
  margin-bottom: 10px;
}

.draft_list li {
  height: 40px;
  line-height: 40px;
  border: 1px solid #ccc;
  border-bottom: none;
  box-sizing: border-box;
  padding: 0 20px;
}

.textarea_f {
  width: 100%;
}

.draft_list li:last-child {
  border-bottom: 1px solid #ccc;
}

.date_picker_n {
  display: none;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  background-color: #fff;
  font-size: 28px;
  color: #8c939d;
  width: 178px !important;
  height: 178px !important;
  line-height: 178px !important;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.drop_down {
  position: absolute;
  z-index: 2005;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background-color: #fff;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 5px 0;
  width: 568px;
  height: auto;
  padding: 5px;
  overflow-y: auto;
}

.close_drop_down {
  position: absolute;
  right: 6px;
  top: 4px;
  font-size: 18px;
  cursor: pointer;
}

.dialog-footer {
  text-align: right;
}
.conBg1 {
  margin-bottom: 5px;
  background-color: #f2f6f7;
  padding: 0 20px 15px 20px;
  margin-top: 10px;
  min-width: 1200px;
}
</style>
